<template>
  <div id="app">
    <v-head v-if="!$route.meta.head" :isShow="$route.meta.isShow"></v-head>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <v-foot v-if="!$route.meta.foot"></v-foot>
  </div>
</template>

<script>
import vHead from "./components/common/header.vue";
import vFoot from "./components/common/footer.vue";
export default {
  name: "App",
  components: {
    vHead,
    vFoot,
  },
  mounted() {
    this.$cookies.config("30d"); //设置所有cookie有效时间为30day
    let flag_token = localStorage.getItem("flag_token");
    if (!flag_token) {
      this.$cookies.remove("peopleId");
      this.$cookies.remove("userInfo");
      localStorage.removeItem("xfh_usertoken");
      location.reload();
      localStorage.setItem("flag_token", true);
    }
  },
};
</script>

<style>
body {
  margin: 0;
  background: #f6f6f6;
}
.el-popover {
  min-width: 0 !important;
}
.el-tooltip__popper.is-light {
  border: none !important;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.11);
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
}
.el-tooltip__popper .popper__arrow {
  border-right-color: rgba(0, 0, 0, 0.08) !important;
}
.el-dialog__title {
  font-size: 20px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  color: #333333;
}
.el-dialog__header {
  padding-bottom: 19px;
  padding-left: 25px;
}

.el-dialog__body {
  border-top: 1px solid #dddddd;
  padding: 21px 5px 30px;
  box-sizing: border-box;
  margin: 0 20px;
}
.el-button--text {
  padding: 0;
}
.el-button.is-disabled.el-button--text,
.el-button.is-disabled.el-button--text:focus,
.el-button.is-disabled.el-button--text:hover {
  color: #ffba88;
}
.v-modal {
  background-color: rgba(0, 0, 0, 0.5) !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue